export default [
    "#3E9BC4",
    "#B24B73",
    "#3EC49B",
    "#C43E3E",
    "#D6DD86",
    "#EAAC2E",
    "#68C2C0",
    "#8460A5",
    "#3B4798",
    "#91C788",
    "#D1EAEF",
    "#E1C389",
    "#F29292",
    "#5A7A4C",
    "#C389BB",
    "#ACB88D",
    "#8E6A9D",
    "#FFD700",
    "#008080",
    "#FF6347",
    "#9370DB",
    "#32CD32",
    "#FF4500",
    "#483D8B",
    "#6A5ACD",
    "#F0E68C",
    "#20B2AA",
    "#DC143C",
    "#2E8B57",
    "#FF69B4",
    "#800080",
    "#FFFF00",
    "#808000",
    "#00FFFF",
    "#000080",
    "#FF00FF",
    "#800000",
    "#008000",
    "#0000FF",
    "#FF0000",
    "#00FF00",
    "#A52A2A",
    "#696969",
    "#DAA520",
    "#708090"
]